<template>
  <Modal :width="299" :gc="gc" :cc="cc" :title="title" ref="modal">
    <div class="two-btn-wrapper modal-content">
      <p class="msg" :style="{'color': gc.main_color}">{{desc}}</p>
      <div class="btn-wrapper">
        <div class="btn btn-cancel"  :style="{'background': cc.modal_cancel_btn || gc.modal_cancel_btn ? `url(${cc.modal_cancel_btn || gc.modal_cancel_btn}) no-repeat center/contain` : '#0B8AFF', 'color': gc.main_color}" @click="closeModal">取消</div>
        <div class="btn btn-confirm" :style="{'background': cc.modal_confirm_btn_small || gc.modal_confirm_btn_small ? `url(${cc.modal_confirm_btn_small || gc.modal_confirm_btn_small}) no-repeat center/contain` : '#0B8AFF', 'color': gc.text_color}" @click="confirm">{{confirm_btn_text}}</div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from './Modal'
export default {
  components: {
    Modal
  },
  props: {
    cc: { // component_conf
      type: Object,
      default: () => {}
    },
    gc: { // common_config
      type: Object,
      default: () => {}
    },
    title: { 
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    confirm_btn_text: {
      type: String,
      default: '确认'
    },
    callback: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    closeModal () {
      this.$refs['modal'].hideModal()
    },
    confirm () {
      this.$emit('callback')
    }
  }
}
</script>

<style lang="less" scoped>
.two-btn-wrapper {
  .msg {
    margin: 14px auto;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    opacity: .6;
    text-align: center;
  }
  .btn-wrapper {
    display: flex;
    justify-content: center;
    .btn {
      width: calc(100% - 9px); 
      height: 36px;
      text-align: center;
      line-height: 36px;
      font-weight: 500;
      font-size: 15px;
      letter-spacing: .25px;
    }
    .btn-cancel {
      margin-right: 9px;
    }
  }
}
</style>